<template>
  <div>
    <v-text-field
      dense
      :masked="false"
      :value="value"
      type="tel"
      outlined
      clearable
      required
      @click:clear="$emit('input', null)"
      :hide-details="errors.length ? false : true"
      :error-messages="errors"
      placeholder="Phone No."
      @input="onInput"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  props: ['value', 'errors'],
  data() {
    return {}
  },
  methods: {
    onInput(event) {
      if (event) {
        let phone_number = event.replace(/-/g, '')
        this.$emit('input', phone_number)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
